<script setup lang="ts">
const props = defineProps<{
  eventId: number
}>()

useApi(`/stats/events/${props.eventId}/visits/`, {
  method: 'POST',
  body: {
    url: window.location.href,
    referrer: document.referrer || '',
  },
})
</script>

<template></template>
